<template>
  <g fill-rule="evenodd" fill="none">
    <path d="M.125.125h19.75v19.75H.125V.125z" />
    <path
      d="M12.693 9.775A2.697 2.697 0 0110 12.47a2.697 2.697 0 01-2.693-2.694A2.697 2.697 0 0110 7.082a2.697 2.697 0 012.693 2.693zm7.182-.402s-2.92 7.584-9.863 7.584c-6.286 0-9.887-7.584-9.887-7.584s3.59-6.78 9.887-6.78c6.302 0 9.863 6.78 9.863 6.78zm-5.387.402A4.492 4.492 0 0010 5.287c-2.475 0-4.488 2.013-4.488 4.488s2.012 4.49 4.488 4.49a4.494 4.494 0 004.488-4.49z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
